import type { EffectDefinition, EffectContext } from './types'

interface Snowflake {
  x: number
  y: number
  radius: number
  speed: number
  drift: number
  phase: number
  opacity: number
}

function createFlake(width: number, height: number): Snowflake {
  return {
    x: Math.random() * width,
    y: Math.random() * height * -0.5,
    radius: 1 + Math.random() * 3,
    speed: 30 + Math.random() * 50,
    drift: 0.3 + Math.random() * 0.7,
    phase: Math.random() * Math.PI * 2,
    opacity: 0.3 + Math.random() * 0.5
  }
}

export const snow: EffectDefinition = {
  id: 'snow',
  name: 'Snowfall',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 5000)
    const flakes: Snowflake[] = []
    for (let i = 0; i < count; i++) {
      const flake = createFlake(ctx.width, ctx.height)
      flake.y = Math.random() * ctx.height
      flakes.push(flake)
    }
    return flakes
  },

  update(state: unknown, ctx: EffectContext) {
    const flakes = state as Snowflake[]
    const dt = ctx.deltaTime / 1000
    for (const flake of flakes) {
      flake.y += flake.speed * dt
      flake.x += Math.sin(ctx.time / 1000 + flake.phase) * flake.drift * dt * 30
      if (flake.y > ctx.height + flake.radius) {
        flake.y = -flake.radius * 2
        flake.x = Math.random() * ctx.width
      }
      if (flake.x < -10) flake.x = ctx.width + 10
      if (flake.x > ctx.width + 10) flake.x = -10
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const flakes = state as Snowflake[]
    const { ctx: c } = ctx
    for (const flake of flakes) {
      c.beginPath()
      c.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2)
      c.fillStyle = `rgba(255, 255, 255, ${flake.opacity})`
      c.fill()
    }
  }
}
